import { useCallback, useEffect } from "react";
import categoryStore from "../stores/categoryStore";
import { getCategoryData } from "../services/categoryService";

export function useCategories() {
  const { categories, setCategories } = categoryStore();

  const getCategories = useCallback(async () => {
    try {
      const data = await getCategoryData();

      const sorted = data.categories.sort(function (a, b) {
        return a.id - b.id;
      });

      setCategories(sorted);
      return data;
    } catch (error) {
      console.error(`Failed to load categories:`, error);
      return [];
    }
  }, [setCategories]);

  return {
    categories,
    setCategories,
    getCategories,
  };
}
